import API from 'js/lib/api';

export default API('/api/onDemandDiscussionQuestions.v1/', {
  type: 'rest',
});
